import React, { useState } from 'react';
import { Box, ClickAwayListener, IconButton } from '@mui/material';
import HelpOutlineRoundedIcon from '@mui/icons-material/HelpOutlineRounded';
import { useTranslation } from 'react-i18next';
import AppTooltip from '../Common/AppTooltip';

const ActionFlowHelp = ({ topic, children, icon }) => {
  const { t } = useTranslation();
  const [hovered, setHovered] = useState(false);
  const [pinned, setPinned] = useState(false);
  const close = () => { setHovered(false); setPinned(false); };
  return <ClickAwayListener onClickAway={close}>
    <Box component="span" sx={{ display: 'inline-flex', verticalAlign: 'middle' }}>
      <AppTooltip title={children} describeChild open={hovered || pinned}
        onOpen={() => setHovered(true)} onClose={() => setHovered(false)}
        componentsProps={{ tooltip: { sx: { maxWidth: 360, maxHeight: 'min(60vh, 420px)',
          overflowY: 'auto', overflowWrap: 'anywhere', whiteSpace: 'pre-line', lineHeight: 1.6,
          '& .MuiTypography-root': { color: 'inherit' } } } }}>
        <IconButton size="small" aria-label={t('dag.flow_assistant.simple.help_for', {
          defaultValue: 'Help: {{topic}}', topic, interpolation: { escapeValue: false },
        })} aria-expanded={hovered || pinned}
          onClick={(event) => { event.stopPropagation(); setPinned((current) => !current); setHovered(false); }}
          onBlur={close} onKeyDown={(event) => {
            if (event.key === 'Escape') { event.stopPropagation(); close(); }
          }} sx={{ color: 'text.secondary', width: { xs: 40, sm: 28 }, height: { xs: 40, sm: 28 } }}>
          {icon || <HelpOutlineRoundedIcon sx={{ fontSize: 18 }} />}
        </IconButton>
      </AppTooltip>
    </Box>
  </ClickAwayListener>;
};

export default ActionFlowHelp;
